// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"714":"856f5ddc","811":"b3b01b95"}[chunkId] + ".chunk.css";
};